import { tns } from 'tiny-slider/src/tiny-slider';
class Grist50PastMultiple {
  constructor() {
    this.carousel = null;
    this.initialize();
  }

  initialize() {

    document.querySelectorAll('.grist50-slide-items-multiple').forEach(slider => {
      this.carousel = tns({
        container: slider,
        nav: false,
        items: 1,
        controlsText: ["",""],
        responsive: {
          600: {
            gutter: 20,
            items: 2,
          },
          900: {
            items: 3,
            gutter: 30,
          }
        }
      });
    });

  }

}

export default Grist50PastMultiple;
